module.exports = __webpack_public_path__ + "assets/media/dizzy_robot.c4fe6292.svg";